import { z } from 'zod';

export const viteEnvSchema = z.object({
  VITE_BACKEND_URL: z.string().min(1),
  VITE_APP_URL: z.string().min(1),
  VITE_SUPABASE_URL: z.string().min(1),
  VITE_SUPABASE_ANON_KEY: z.string().min(1),
  VITE_GITHUB_REDIRECT_URL: z.string().min(1),
  VITE_FLAG_CLIENT_ID: z.string().min(1),
  VITE_GITHUB_CLIENT_ID: z.string().min(1),
  VITE_GITLAB_CLIENT_ID: z.string().min(1),
  VITE_GITLAB_REDIRECT_URI: z.string().url(),
  VITE_POSTHOG_API_KEY: z.string().min(1),
  VITE_SENTRY_DSN: z.string().min(1),
  VITE_WS_URL: z.string().min(1),
  VITE_SLACKBOT_URL: z.string().min(1),
});
